module.exports = __webpack_public_path__ + "c8b6fe6f210db4fc507fa167a135ec61.svg";